import React, { Fragment, useState, useMemo } from "react";
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Form,
} from "reactstrap";
import SweetAlert from "sweetalert2";

import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import axios from "axios";
import { API_INVOICE, API_USER } from "../../../redux/apiRoutes";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Typeahead } from "react-bootstrap-typeahead";
import DatePicker from 'react-datepicker';
import es from "date-fns/locale/es";
import { v4 as uuidv4 } from 'uuid';
import FilterComponent from "../../common/filter";
import { encodeURI } from "js-base64";

function Invoice(props) {
  const user = useSelector((content) => content.User);
  const navigate = useNavigate();

  const [modalNew, setModalNew] = useState(false);
  const toggleNew = () => { setModalNew(!modalNew); reset(); setInvoiceTotal(0); clearModal(); };

  const [modal, setModal] = useState(false);
  const toggle = () => { setModal(!modal); reset(); setEditinInvoice(false); setInvoiceTotal(0); clearModal() };

  const clearModal = () => {
    setCurrentInvoice({});
    setcurrentschemePayment('');
    setcurrentgrade([]);
    setStudentSelected([]);
    setDate(new Date());
  }

  const handleEditAction = (invoice) => {
    toggle();
    setEditinInvoice(true);
    setCurrentInvoice(invoice);

    setTimeout(() => {
      setValue('amount', invoice.amount);
      setValue('discount', invoice.discount);
      setValue('charge', invoice.charge);
      setValue('total', invoice.total);
      setValue('status', invoice.status);
      setInvoiceTotal(invoice.total);
    }, 500)
  }

  const [invoiceTotal, setInvoiceTotal] = useState(0);
  const calculateTotal = () => {
    let am = getValues('amount');
    let ds = getValues('discount');
    let ch = getValues('charge');

    setInvoiceTotal(0 + (Number(am) + Number(ch)) - Number(ds));
    setValue('total', 0 + (Number(am) + Number(ch)) - Number(ds));
  }

  const [currentInvoice, setCurrentInvoice] = useState({});

  const handleDeleteAction = (data) => {
    SweetAlert.fire({
      title: "¿Continuamos?",
      text: `Se eliminará la colegiatura del periodo ${data.period} por $${data.total} para ${data.studentName}. ¡Está acción es irreversible!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        await axios.delete(`${API_INVOICE}/${data.uuid}`).then(response => {
          getInvoiceList();
          SweetAlert.fire("¡Listo!", "colegiatura eliminada", "success");
        }).catch(error => {
          setTimeout(() => {
            toast.error(
              "Error al eliminar la colegiatura: " + error
            );
          }, 200);
        });
      }
    });
  }

  const [studentSelected, setStudentSelected] = useState([]);
  const [dataStudents, setdataStudents] = useState([]);
  const getStudentsList = async () => {
    await axios.get(`${API_USER}?status=ACTIVE&role=STUDENT`).then(response => {
      if (response.data.docs.length > 0) {
        const students = []
        response.data.docs.map(student => {
          const addStudent = {
            uuid: student.uuid,
            name: student.names + ' ' + student.second_names,
            discount: student.discount,
            schemePayment: student.schemePayment,
            grade: student.grade,
          }
          students.push(addStudent);
        });
        setdataStudents(students);
      }
    }).catch(e => {
      toast.error("No se pudo obtener el listado de Estudiantes: " + e.message, { position: 'bottom-right', style: { color: 'white' } });
    });
  }

  const [currentgrade, setcurrentgrade] = useState('');
  const [currentschemePayment, setcurrentschemePayment] = useState('');

  const handleSelectStudent = async (e) => {
    setStudentSelected(e);

    e.map(student => {
      setcurrentschemePayment(student.schemePayment);
      setcurrentgrade(student.grade[0]);

      let subtotal = 2350;
      if (student.schemePayment === 'DIEZ_MESES') {
        subtotal = 2350;
      }

      setValue('amount', subtotal);
      setValue('discount', student.discount);
      setValue('charge', 0);
      calculateTotal();
    });
  }

  const estado = (status) => {
    switch (status) {
      case 'PAGADA':
        return <div><span className="badge badge-success">PAGADA</span> <br /></div>;
      case 'PENDIENTE':
        return <div><span className="badge badge-secondary">PENDIENTE</span> <br /></div>;
      case 'CANCELADA':
        return <div><span className="badge badge-danger">CANCELADA</span> <br /></div>;
    }
  }

  const columns = [
    {
      name: "Periodo",
      selector: (row) => <b>{row.period}</b>,
      sortable: true,
      center: true,
      width: '150px'
    },
    {
      name: "Alumno(a)",
      selector: (row) => <b>{row.studentName}</b>,
      sortable: true,
      center: true,
      width: '150px'
    },
    {
      name: "Grado",
      selector: (row) => row.grade,
      sortable: true,
      center: true,
      width: '150px'
    },
    {
      name: "Estado",
      selector: (row) => estado(row.status),
      sortable: true,
      center: true,
      width: '150px'
    },
    {
      name: "Esquema",
      selector: (row) => row.schemePayment,
      sortable: true,
      center: true,
    },
    {
      name: "Total",
      selector: (row) => <b>${row.total}</b>,
      sortable: true,
      center: true,
    },
    {
      name: "Creada",
      selector: (row) => row.createdAt ? new Date(row.createdAt).getDate() + '-' + (new Date(row.createdAt).getMonth() + 1) + '-' + new Date(row.createdAt).getFullYear() : '--',
      sortable: true,
      center: true,
    },
    {
      name: "Acciones",
      selector: (row) => <div style={{ padding: 5 }}>
        {editPermissions ?
          <>
            <Button color="light" style={{ width: 40, padding: 6, marginRight: 5, fontSize: 14 }} onClick={() => { handleEditAction(row) }}><i className="fa fa-pencil"></i></Button>
            {row.status === 'PENDIENTE' ?
              <a href={`https://wa.me/${row.tutorPhone}?text=${decodeURI(`Hola ${row.tutorName}, te recordamos que está pendiente el pago de tu mensualidad *Por $${row.total} del periodo ${row.period}* agradeceremos nos apoyes con tu pago a la brevedad posible.`)}`} target="_blank"><Button color="light" style={{ width: 40, padding: 6, marginRight: 5, fontSize: 14 }}><i className="fa fa-whatsapp"></i></Button></a> : null}
            <Button color="light" style={{ width: 40, padding: 6, marginRight: 5, fontSize: 14 }} onClick={() => { handleDeleteAction(row) }}><i className="fa fa-trash"></i></Button>
          </>
          :
          <Button color="light" style={{ width: 40, padding: 6, marginRight: 5, fontSize: 14 }} onClick={() => { handleEditAction(row) }}><i className="fa fa-search"></i></Button>
        }
      </div>,
      width: '210px'
    },
  ];

  const [dataInvoice, setDataInvoice] = useState([]);
  const [getInvoice, setGetInvoice] = useState(false);
  const [editPermissions, setEditPermissions] = useState(false);
  const getInvoiceList = async () => {
    setGetInvoice(true);

    let queryRule = '';
    if (user.role === 'TUTOR') {
      queryRule = `&tutorUuid=${user.uuid}`;
    }

    if (user.role === 'ADMIN' || user.role === 'SISTEMAS' || user.role === "DIRECTOR") {
      setEditPermissions(true);
    }

    await axios.get(`${API_INVOICE}?${queryRule}`).then(response => {
      if (response.data.docs.length > 0) {
        setDataInvoice(response.data.docs);
      } else {
        setDataInvoice([]);
      }
      setGetInvoice(false);
    }).catch(e => {
      setGetInvoice(false);
      toast.error("No se pudo obtener el listado de Alumnos: " + e.message, { position: 'bottom-right', style: { color: 'white' } });
    });
  }

  const [date, setDate] = useState(new Date());
  const handleChangeStart = (date) => {
    setDate(date);
  };

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const [creatingInvoice, setcreatingInvoice] = useState(false);
  const createInvoice = async (data) => {
    setcreatingInvoice(true);

    if (studentSelected.length <= 0) {
      toast.error("Asigna un alumno(a) a la nueva factura", { position: 'bottom-right', style: { color: 'white' } });
      setcreatingInvoice(false);
      return;
    }

    if (date === "" || date === null) {
      toast.error("Asigan un periodo de pago a la factura", { position: 'bottom-right', style: { color: 'white' } });
      setcreatingInvoice(false);
      return;
    }

    const dataInvoice = {
      uuid: uuidv4(),
      studentUuid: studentSelected[0].uuid,
      amount: data.amount === '' || data.amount === null ? 0 : data.amount,
      discount: data.discount === '' || data.discount === null ? 0 : data.discount,
      charge: data.charge === '' || data.charge === null ? 0 : data.charge,
      total: invoiceTotal,
      period: date,
      tax: 0,
      schemePayment: currentschemePayment,
      grade: currentgrade.name,
      status: data.status,
      charged: data.charge > 0 && data.charge !== '' ? true : false,
    }

    await axios.post(`${API_INVOICE}`, dataInvoice).then(response => {
      getInvoiceList();
      toggleNew();
      setcreatingInvoice(false);
    }).catch(error => {
      setTimeout(() => {
        toast.error(
          "Error al crear la factura: " + error
        );
      }, 200);
      setcreatingInvoice(false);
    });
  }

  const [isEditingInvoice, setEditinInvoice] = useState(false);
  const [patchingInvoice, setPatchingInvoice] = useState(false);
  const patchInvoice = async (data) => {
    // Verificar si se está marcando como PAGADA y si el tutor tiene data fiscal
    if (data.status === 'PAGADA' && currentInvoice.tutorFiscalData && currentInvoice.tutorFiscalData.useInvoice) {
      // Mostrar advertencia antes de proceder
      const confirmResult = await SweetAlert.fire({
        title: "⚠️ Generación de Factura",
        html: `
          <div style="text-align: left;">
            <p><strong>Se generará automáticamente una factura fiscal para:</strong></p>
            <ul>
              <li><strong>Tutor:</strong> ${currentInvoice.tutorName}</li>
              <li><strong>Alumno:</strong> ${currentInvoice.studentName}</li>
              <li><strong>Período:</strong> ${currentInvoice.period}</li>
              <li><strong>Monto:</strong> $${currentInvoice.total}</li>
            </ul>
            <p style="color: #007bff; font-weight: bold;">La factura se enviará al correo del tutor.</p>
            <p>¿Deseas continuar?</p>
          </div>
        `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, Generar Factura",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#28a745",
        cancelButtonColor: "#dc3545",
        reverseButtons: true,
        width: '500px'
      });

      if (!confirmResult.isConfirmed) {
        return; // Cancelar la operación
      }
    }

    setPatchingInvoice(true);

    await axios.patch(`${API_INVOICE}/${currentInvoice.uuid}`, data).then(response => {
      getInvoiceList();
      toggle();
      setPatchingInvoice(false);

      // Manejar diferentes tipos de respuesta del backend
      if (response.data.success === false) {
        // Respuesta de error del backend
        if (response.status === 206) { // PARTIAL_CONTENT - colegiatura actualizada pero error en factura
          SweetAlert.fire({
            title: "⚠️ Atención",
            text: response.data.message,
            icon: "warning",
            confirmButtonText: "Entendido",
          });
        } else {
          // Otros errores del backend
          SweetAlert.fire({
            title: "❌ Error",
            text: response.data.message,
            icon: "error",
            confirmButtonText: "Entendido",
          });
        }
      } else {
        // Respuesta exitosa
        if (data.status === 'PAGADA' && currentInvoice.tutorFiscalData && currentInvoice.tutorFiscalData.useInvoice) {
          toast.success("✅ Colegiatura marcada como pagada y factura generada exitosamente", {
            position: 'bottom-right',
            style: { color: 'white' },
            duration: 5000
          });
        } else if (data.status === 'PAGADA') {
          toast.success("✅ Colegiatura marcada como pagada", {
            position: 'bottom-right',
            style: { color: 'white' }
          });
        } else {
          toast.success("✅ Estado de colegiatura actualizado", {
            position: 'bottom-right',
            style: { color: 'white' }
          });
        }
      }
    }).catch(error => {
      setTimeout(() => {
        // Manejar errores de red o del servidor
        let errorMessage = "Error al actualizar el estado de la factura";

        if (error.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error.response?.data?.error) {
          errorMessage = error.response.data.error;
        } else if (error.message) {
          errorMessage = error.message;
        }

        // Mostrar toast de error específico
        if (data.status === 'PAGADA' && currentInvoice.tutorFiscalData && currentInvoice.tutorFiscalData.useInvoice) {
          SweetAlert.fire({
            title: "❌ Error al generar la factura",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "Entendido"
          });
        } else {
          toast.error(`❌ ${errorMessage}`, {
            position: 'bottom-right',
            style: { color: 'white' },
            duration: 6000
          });
        }
      }, 200);
      setPatchingInvoice(false);
    });
  }

  useEffect(() => {
    getStudentsList();
    getInvoiceList();
    if (
      user.role !== 'ADMIN'
      && user.role !== "SISTEMAS"
      && user.role !== "TUTOR"
      && user.role !== "DIRECTOR"
      && user.role !== "SUBDIRECTOR"
    ) {
      navigate('/inicio');
    }
  }, [navigate]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(
    false
  );

  const filteredItems = dataInvoice.filter(
    item =>
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(filterText.toLowerCase()) !== -1
  );

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={e => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  return (
    <Fragment>
      <Breadcrumb parent="Finanzas" title="Colegiaturas" />
      <Container fluid={true}>
        {editPermissions ?
          <Row>
            <Col sm="12" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 20, paddingRight: 30 }}>
              <Button color="primary" onClick={toggleNew}>Crear Nueva</Button>
            </Col>
          </Row> : null}
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="data-tables">
                <DataTable
                  columns={columns}
                  striped={true}
                  center={true}
                  data={filteredItems}
                  pagination
                  subHeader
                  subHeaderComponent={subHeaderComponent}
                  noDataComponent={<b style={{ padding: 10 }}>No hay colegiaturas registradas</b>}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

      </Container>

      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Colegiatura
          <button className="btn-close invisible" type="button">
            <span aria-hidden="true" className="visible" onClick={toggle}></span>
          </button>
        </ModalHeader>
        <ModalBody>
          <div className="container">
            <Form className="needs-validation" noValidate="" onSubmit={handleSubmit(patchInvoice)} style={{ padding: 20 }}>
              <Row className="g-3 dflex mb-3" style={{ background: '#e4e4e4', padding: 10, borderRadius: 10 }}>
                <Col md="12">
                  <Label className="form-label font-weight-bold" for="validationCustom01">
                    Estado del Pago
                  </Label>
                  {editPermissions ?
                    <select name="status" className="form-control mb-1" id="validationCustom01" type="text" {...register("status", { required: true })}>
                      <option value="PAGADA">PAGADA</option>
                      <option value="PENDIENTE">PENDIENTE DE PAGO</option>
                      <option value="CANCELADA">CANCELADA</option>
                    </select>
                    :
                    <h5>{estado(currentInvoice.status)}</h5>
                  }
                </Col>
              </Row>
              <Row className="g-3 dflex mb-3">
                <Col md="12">
                  <Label className="form-label font-weight-bold">
                    Periodo:
                  </Label>
                  <br />
                  <h5>{currentInvoice.period}</h5>
                </Col>
              </Row>
              <Row className="g-3 dflex mb-3">
                <Col md="12">
                  <Label className="form-label font-weight-bold">
                    Alumno(a):
                  </Label>
                  <br />
                  <h5>{currentInvoice.studentName}</h5>
                </Col>
              </Row>
              <Row className="g-3 dflex mb-3">
                <Col md="12">
                  <Label className="form-label font-weight-bold">
                    Tutor(a):
                  </Label>
                  <br />
                  <h5>{currentInvoice.tutorName}</h5>
                </Col>
              </Row>
              <Row className="g-3 dflex mb-3">
                <Col md="12">
                  <Label className="form-label font-weight-bold">
                    Grado:
                  </Label>
                  <br />
                  <h5>{currentInvoice.grade}</h5>
                </Col>
              </Row>
              <Row className="g-3 dflex mb-3">
                <Col md="12">
                  <Label className="form-label font-weight-bold">
                    Esquema de Pago:
                  </Label>
                  <br />
                  <h5>{currentInvoice.schemePayment}</h5>
                </Col>
              </Row>
              <Row className="g-3 dflex mb-2 mt-2">
                <Col md="12">
                  <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <span style={{ width: 220, textAlign: 'end' }}>Subtotal: $</span> &nbsp;
                    <input disabled={!editPermissions} className="form-control" id="validAmount" type="text" placeholder="subtotal" name="amount" {...register("amount", { required: true })} onKeyUp={calculateTotal} />
                    <span>{errors.amount && "Subtotal requerido"}</span>
                  </h5>
                </Col>
              </Row>
              <Row className="g-3 dflex mb-2">
                <Col md="12">
                  <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <span style={{ width: 220, textAlign: 'end' }}>- Descuento: $</span> &nbsp;
                    <input disabled={!editPermissions} className="form-control" id="validdiscount" type="text" placeholder="descuento" name="discount" {...register("discount")} onKeyUp={calculateTotal} />
                  </h5>
                </Col>
              </Row>
              <Row className="g-3 dflex mb-2">
                <Col md="12">
                  <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <span style={{ width: 220, textAlign: 'end' }}>+ Recargos: $</span> &nbsp;
                    <input disabled={!editPermissions} className="form-control" id="validcharge" type="text" placeholder="recargos" name="charge" {...register("charge")} onKeyUp={calculateTotal} />
                  </h5>
                </Col>
              </Row>
              <Row className="g-3 dflex mb-2">
                <Col md="12" style={{ textAlign: 'end' }}>
                  <h4 className="form-label font-weight-bold">
                    Total: &nbsp;
                    <b>${invoiceTotal}</b>
                    <input hidden disabled className="form-control" id="validdtotal" type="text" placeholder="total" name="total" {...register("total")} />
                  </h4>
                </Col>
              </Row>
              <Row style={{ display: 'flex', justifyContent: 'end', paddingTop: 20 }}>
                {
                  editPermissions ?
                    isEditingInvoice ?
                      <Button disabled={patchingInvoice} className="btn btn-primary" style={{ width: 150 }} color="primary">{"Guardar"}</Button>
                      : null
                    : null
                }
              </Row>
            </Form>
          </div>
        </ModalBody>
      </Modal>

      {editPermissions ?
        <Modal isOpen={modalNew} toggle={toggleNew}>
          <ModalHeader toggle={toggleNew}>Nueva Colegiatura
            <button className="btn-close invisible" type="button">
              <span aria-hidden="true" className="visible" onClick={toggleNew}></span>
            </button>
          </ModalHeader>
          <ModalBody>
            <div className="container">
              <Form className="needs-validation" noValidate="" onSubmit={handleSubmit(createInvoice)} style={{ padding: 20 }}>
                <Row className="g-3 dflex mb-3" style={{ background: '#e4e4e4', padding: 10, borderRadius: 10 }}>
                  <Col md="12">
                    <Label className="form-label font-weight-bold" for="validationCustom01">
                      Estado del Pago
                    </Label>
                    <select name="status" className="form-control mb-1" id="validationCustom01" type="text" {...register("status", { required: true })}>
                      <option value="PENDIENTE">PENDIENTE DE PAGO</option>
                      <option value="PAGADA">PAGADA</option>
                    </select>
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-3">
                  <Col md="12">
                    <Label className="form-label font-weight-bold">
                      Periodo:
                    </Label>
                    <DatePicker className="form-control digits"
                      selected={date}
                      onChange={handleChangeStart}
                      selectsStart
                      minDate={new Date()}
                      locale={es}
                      showMonthYearPicker
                      dateFormat={'M-yyyy'}
                    />
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-3">
                  <Col md="12">
                    <Label className="form-label font-weight-bold">
                      Alumno(a):
                    </Label>
                    <Typeahead
                      id="gradeFinder"
                      clearButton
                      defaultSelected={studentSelected}
                      labelKey="name"
                      options={dataStudents}
                      placeholder="Buscar Alumno(a)..."
                      onChange={(e) => { handleSelectStudent(e) }}
                    />
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-3">
                  <Col md="12">
                    <Label className="form-label font-weight-bold">
                      Grado:
                    </Label>
                    <br />
                    <h5>{currentgrade !== "" ? currentgrade.name : ''}</h5>
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-3">
                  <Col md="12">
                    <Label className="form-label font-weight-bold">
                      Esquema de Pago:
                    </Label>
                    <br />
                    <h5>{currentschemePayment}</h5>
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-2 mt-2">
                  <Col md="12">
                    <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
                      <span style={{ width: 220, textAlign: 'end' }}>Subtotal: $</span> &nbsp;
                      <input className="form-control" id="validAmount" type="text" placeholder="subtotal" name="amount" {...register("amount", { required: true })} onKeyUp={calculateTotal} />
                      <span>{errors.amount && "Subtotal requerido"}</span>
                    </h5>
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-2">
                  <Col md="12">
                    <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
                      <span style={{ width: 220, textAlign: 'end' }}>- Descuento: $</span> &nbsp;
                      <input className="form-control" id="validdiscount" type="text" placeholder="descuento" name="discount" {...register("discount")} onKeyUp={calculateTotal} />
                    </h5>
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-2">
                  <Col md="12">
                    <h5 className="form-label font-weight-bold flex d-flex" style={{ justifyContent: 'center', alignItems: 'center' }}>
                      <span style={{ width: 220, textAlign: 'end' }}>+ Recargos: $</span> &nbsp;
                      <input className="form-control" id="validcharge" type="text" placeholder="recargos" name="charge" {...register("charge")} onKeyUp={calculateTotal} />
                    </h5>
                  </Col>
                </Row>
                <Row className="g-3 dflex mb-2">
                  <Col md="12" style={{ textAlign: 'end' }}>
                    <h4 className="form-label font-weight-bold">
                      Total: &nbsp;
                      <b>${invoiceTotal}</b>
                      <input hidden disabled className="form-control" id="validdtotal" type="text" placeholder="total" name="total" {...register("total")} />
                    </h4>
                  </Col>
                </Row>
                <Row style={{ display: 'flex', justifyContent: 'end', paddingTop: 20 }}>
                  <Button disabled={creatingInvoice} className="btn btn-primary" style={{ width: 150 }} color="primary">{"Crear"}</Button>
                </Row>
              </Form>
            </div>
          </ModalBody>
        </Modal> : null}

    </Fragment>
  );
}

export default Invoice;
